import { Search } from '@/DTOS/Notification/Search';
import request from '../../utils/request';

const NotificationService = {
  search: (search: Search) => {
    return request('/Telegram/search-notification', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },
  count: () => {
    return request('/Telegram/count-notification', {
      method: 'GET',
    });
  },
};
export default NotificationService;
